import { axios } from 'shared';

export type CompleteSlackOAuthResponse = {
  success: boolean;
  error?: string;
  /** `slack://` URL to open Codi AI Office Assistant in the Slack client; omitted or null if unavailable. */
  app_home_deep_link?: string | null;
  /** Bot scopes still missing after install. Present only when scope upgrade is needed. */
  missing_scopes?: string[];
};

export function completeSlackOAuth(code: string, state: string) {
  return axios.post<CompleteSlackOAuthResponse>('/v1/slack/oauth/callback', { code, state });
}
